import { PayloadAction } from '@reduxjs/toolkit';
import { DesignState } from 'src/store/design/types';

const setDesignEncPublicIdReducer = (state: DesignState, action: PayloadAction<string | undefined>) => {
  state.encPublicId = action.payload;
};

export default setDesignEncPublicIdReducer;
